var storefrontApp = angular.module('storefrontApp');

storefrontApp.controller('productController', ['$rootScope', '$scope', '$window', '$analytics', 'dialogService', 'catalogService', 'cartService', 'quoteRequestService', 'customerService', 'listService', '$localStorage', 'zipCodeService', '$$cookieReader',
    function ($rootScope, $scope, $window, $analytics, dialogService, catalogService, cartService, quoteRequestService, customerService, listService, $localStorage, zipCodeService, $$cookieReader) {
        //TODO: prevent add to cart not selected variation
        // display validator please select property
        // display price range

        var allVariations = [];

        $scope.selectedVariation = {};
        $scope.allVariationPropsMap = {};
        $scope.productPrice = null;
        $scope.productPriceLoaded = false;
        $scope.addToWishlistDisabled = false;
        $scope.availableLists = null;
        $scope.listType = null;
        $scope.sizeListType = null;
        $scope.onChangePrimaryImage = null;
        $scope.selectedSizeListType = {};
        $scope.isCollapsedSizeType = false;
        $scope.initControl = true;

        $scope.postalCode = null;
        $scope.address = {};
        $scope.foundPostalCode = null;
        $scope.searchPostalCode = false;

        $scope.showAllShippingMethods = false;
        $scope.availShippingMethods = [];
        $scope.getingAvailShippingMethods = false;

        $scope.isAvailableVariation = function (property) {
            var selecteds = getSelectedPropsMap($scope.allVariationPropsMap);
            selecteds[property.displayName] = [property];
            var isAvailable = findVariationByProperties(allVariations, selecteds).isAvailable;
            return isAvailable; 
        };

        $scope.selectPrimaryImage = function (image) {
            $scope.selectedVariation.primaryImage = image;
            if ($scope.onChangePrimaryImage != null) {
                $scope.onChangePrimaryImage(image);
            }
        };

        $scope.addProductToCart = function (product, quantity) {
            var dialogData = toDialogDataModel(product, quantity);
            dialogService.showDialog(dialogData, 'recentlyAddedCartItemDialogController', 'storefront.recently-added-cart-item-dialog.tpl');
            var sku = product.sku;
            // get parent sku for variations
            if (allVariations != null && allVariations.length > 1) {
                sku = allVariations[0].sku;
            };
            $analytics.eventTrack('AddToCart', { content_ids: [sku], content_type : 'product', content_name : product.name, currency: product.currency.code, value: product.price.actualPrice.amount });
            var cookies = $$cookieReader();
            var dinamyc = {};
            _.each(_.filter(_.keys(cookies), function (k) { return k.includes("utm_") }), function (i) { dinamyc[i] = decodeURI(cookies[i]); });

            cartService.addLineItem(product.id, quantity, dinamyc).then(function (response) {
                $rootScope.$broadcast('cartItemsChanged');
            });
        };
        $scope.addProductToCartById = function (productId, quantity, event) {
            event.preventDefault();
            catalogService.getProduct([productId]).then(function (response) {
                if (response.data && response.data.length) {
                    var product = response.data[0];
                    $scope.addProductToCart(product, quantity);
                }
            });
        };
        $scope.addProductToWishlist = function (product) {
            var dialogData = toDialogDataModel(product, 1);
            dialogData.listType = $scope.listType;
            dialogService.showDialog(dialogData, 'recentlyAddedListItemDialogController', 'storefront.recently-added-list-item-dialog.tpl');
        };
        $scope.addProductToActualQuoteRequest = function (product, quantity) {
            var dialogData = toDialogDataModel(product, quantity);
            dialogService.showDialog(dialogData, 'recentlyAddedActualQuoteRequestItemDialogController', 'storefront.recently-added-actual-quote-request-item-dialog.tpl');
            quoteRequestService.addProductToQuoteRequest(product.id, quantity).then(function (response) {
                $rootScope.$broadcast('actualQuoteRequestItemsChanged');
            });
        };

        $scope.initAvailableLists = function (lists, sizeListType) {
            $scope.listType = lists.default_list_type;
            $scope.sizeListType = sizeListType;
        }

        $scope.clearPostalCode = function () {
            $scope.postalCode = null;
            $scope.availShippingMethods = [];
            $scope.address = {};
            savePostalCode();
        }

        $scope.changePostalCode = function () {
            getAvailShippingMethods();
            $scope.address = {};
            searchPostalCode(true);
        }

        $scope.$watch('postalCode', function (newValue, oldValue) {
            if (newValue != oldValue) {
                $scope.foundPostalCode = null;
                $scope.availShippingMethods = [];
            }
        });

        function toDialogDataModel(product, quantity) {
            return {
                imageUrl: product.primaryImage ? product.primaryImage.url : null,
                listPrice: product.price.listPrice,
                id: product.id,
                listPriceWithTax: product.price.listPriceWithTax,
                name: product.name,
                placedPrice: product.price.actualPrice,
                placedPriceWithTax: product.price.actualPriceWithTax,
                quantity: quantity,
                updated: false
            };
        }

        function initialize() {

            loadPostalCode();
            if ($scope.postalCode) {
                searchPostalCode(false);
            }

            var productIds = _.map($window.products, function (product) { return product.id });
            if (!productIds || !productIds.length) {
                return;
            }
            catalogService.getProduct(productIds).then(function (response) {
                var product = response.data[0];

                $analytics.eventTrack('ViewContent', { content_ids: [product.sku], content_type: 'product', content_name: product.name, currency: product.currency.code, value: product.price.actualPrice.amount });

                //Current product is also a variation (titular)
                allVariations = [product].concat(product.variations || []);
                $scope.allVariationPropsMap = getFlatternDistinctPropertiesMap(allVariations);

                _.each(_.keys($scope.allVariationPropsMap), function (mapKey) {
                    _.each($scope.allVariationPropsMap[mapKey], function (prop) {
                        prop.available = true;
                    });
                });

                var defaultProduct = product;
                if (product.variations.length > 0) {
                    // check if product have full options fill
                    var propertyMap = getVariationPropertyMap(product);
                    var invalid = false;
                    _.each(_.keys(propertyMap), function (x) {
                        if (!_.first(propertyMap[x]).value) {
                            invalid = true;
                        }
                    });
                    if (invalid) {
                        defaultProduct = _.find(product.variations, function (y) {
                            return y.isAvailable;
                        });
                    }
                }


                var propertyMap = getVariationPropertyMap(defaultProduct);
                var keys = _.keys(propertyMap);

                if (_.first(keys)) {
                    _.each(keys, function (key) {
                        $scope.checkProperty(propertyMap[key][0]);
                    });
                }
                else {
                    //Auto select initial product as default variation  (its possible because all our products is variations)
                    $scope.selectedVariation = defaultProduct;
                    $scope.selectedSizeListType = getCurrenteSizeListType();
                    if ($scope.onChangePrimaryImage != null) {
                        $scope.onChangePrimaryImage($scope.selectedVariation.primaryImage);
                    }
                }

                if ($scope.postalCode) {
                    getAvailShippingMethods();
                }

                $scope.initControl = false;
            });
        }

        function getCurrenteSizeListType() {
            var grade_numeracao = _.findWhere($scope.selectedVariation.properties, { indexKey: "Grade_Numeracao" });
            var composicao_peca = _.findWhere($scope.selectedVariation.properties, { indexKey: "composicao_peca" });
            var size = _.findWhere($scope.selectedVariation.variationProperties, { indexKey: "Size" });
            var grid = {};
            var sortValues = composicao_peca.values.sort();
            _.each(sortValues, function (peca) {
                grid[peca] = $scope.sizeListType[grade_numeracao.value][peca][size.value];
            });

            return grid;
        }

        function getFlatternDistinctPropertiesMap(variations) {
            var retVal = {};
            _.each(variations, function (variation) {
                var propertyMap = getVariationPropertyMap(variation);
                //merge
                _.each(_.keys(propertyMap), function (x) {
                    if (variations.length == 1 || _.first(propertyMap[x]).value) {
                        retVal[x] = _.uniq(_.union(retVal[x], propertyMap[x]), "value");
                    }
                });
            });
            return retVal;
        }

        function getVariationPropertyMap(variation) {
            return _.groupBy(variation.variationProperties, function (x) { return x.displayName; });
        }

        function getSelectedPropsMap(variationPropsMap) {
            var retVal = {};
            _.each(_.keys(variationPropsMap), function (x) {
                var property = _.find(variationPropsMap[x], function (y) {
                    return y.selected;
                });
                if (property) {
                    retVal[x] = [property];
                }
            });
            return retVal;
        }

        function comparePropertyMaps(propertyMap1, propertyMap2) {
            return _.size(propertyMap1) == _.size(propertyMap2) && _.every(_.keys(propertyMap1), function (x) {
                var result = propertyMap2.hasOwnProperty(x);
                if (result) {
                    result = propertyMap1[x][0].value == propertyMap2[x][0].value;
                }
                return result;
            });
        }

        function findVariationByProperties(variations, selectedPropMap) {
            return _.find(variations, function (x) {
                return comparePropertyMaps(getVariationPropertyMap(x), selectedPropMap);
            });
        }

        function filterVariationByProperties(variations, selectedPropMap) {
            return _.filter(variations, function (variation) {
                return comparePropertyMaps(selectedPropMap, getVariationPropertyMap(variation));
            });
        }

        function isPropertyAvailable(property, key) {
            var allVariationsMaps = angular.copy($scope.allVariationPropsMap);
            _.each(allVariationsMaps[key], function (prop) {
                prop.selected = false;
            });
            var workProperty = _.find(allVariationsMaps[key], function (localProperty) { return localProperty.value === property.value; });
            workProperty.selected = true;
            var variations = filterVariationByProperties(allVariations, getSelectedPropsMap(allVariationsMaps));
            if(variations.length) {
                return true;
            }
            return false;
        }

        function getAvailShippingMethods() {
            if (!$scope.postalCode) {
                $scope.availShippingMethods = [];
                return;
            }
            $scope.getingAvailShippingMethods = true;
            cartService.getAvailableShippingPrices($scope.postalCode, $scope.selectedVariation.id).then(function (response) {
                $scope.getingAvailShippingMethods = false;
                $scope.availShippingMethods =  response.data;
            });
        }

        function savePostalCode() {
            $localStorage['PostalCode'] = $scope.postalCode;
        }

        function loadPostalCode() {
            $scope.postalCode = $localStorage['PostalCode'];
        }

        function buildLine1() {
            if (!angular.isDefined($scope.address)) {
                return;
            };
            var line1Array = [];
            if ($scope.address.countryCode == 'BRA') {
                line1Array = [$scope.address.street, $scope.address.district, $scope.address.city];
            }
            else {
                line1Array = [$scope.address.number, $scope.address.district, $scope.address.city];
            }
            line1Array = line1Array.filter(function (i) { return i != '' && i != undefined });
            $scope.address.line1 = line1Array.join(', ');
        }

        function searchPostalCode(save) {
            if (!$scope.postalCode) {
                return;
            }
            $scope.searchPostalCode = true;
            zipCodeService.search($scope.postalCode).then(function (response) {
                $scope.address = response.data;
                if (save && $scope.address) {
                    savePostalCode();
                }
                
                $scope.foundPostalCode = $scope.address != "";
                
                $scope.searchPostalCode = false;
                buildLine1();
            });
        }

        //Method called from View when user clicks one property value
        $scope.checkProperty = function (property) {
            //Select appropriate property and unselect previous selection

            _.each($scope.allVariationPropsMap[property.displayName], function (prop) {
                prop.selected = prop != property ? false : !prop.selected;
            });

            _.each(_.keys($scope.allVariationPropsMap), function (key) {
                _.each($scope.allVariationPropsMap[key], function (prop) {

                    if($scope.allVariationPropsMap[key].length == 1) {
                        $scope.allVariationPropsMap[key][0].selected = true;
                    }
                    else {
                        var originalProperty = _.find($scope.allVariationPropsMap[key], function (localProperty) { return localProperty.value === prop.value; });
                        originalProperty.available = isPropertyAvailable(prop, key);
                    }
                });
            });

            //try to find the best variation match for selected properties
            $scope.selectedVariation = findVariationByProperties(allVariations, getSelectedPropsMap($scope.allVariationPropsMap));
            $scope.selectedSizeListType = getCurrenteSizeListType();
            if ($scope.onChangePrimaryImage != null) {
                $scope.onChangePrimaryImage($scope.selectedVariation.primaryImage);
            }
            getAvailShippingMethods();
        };

        initialize();
    }]);
